<template>
  <div class="PartnerProfileUpdate">PartnerProfileUpdate</div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
// import store, * as Store from '@/../src-gen/store';
// import * as Data from '@/../src-gen/data';
// import * as ServerData from '@/../src-gen/server-data';
// import * as Action from '@/../src-gen/action';

@Component({
  components: {},
})
export default class PartnerProfileUpdate extends Vue {}
</script>

<style></style>
